import { Mixit } from '../../../libs/gin-tonic/components/mixitup';
import { SwiperItem } from '../../../libs/gin-tonic/components/swiper';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-sliders' })
export class SlidersComponent {
	private mixitup;
	private swiperItem: SwiperItem;
	private navs: HTMLElement[];

	constructor(private element: HTMLElement) {
		const maxPerView = parseInt(
			this.element.getAttribute('data-slider-max-per-view') || '3'
		);
		this.mixitup = new Mixit(this.element, { animationDuration: 0 });
		this.navs = Array.from(
			this.element.querySelectorAll<HTMLElement>('.js-sliders-nav')
		);

		this.swiperItem = new SwiperItem(this.element, {
			scale: false,
			spacing: 40,
			vertical: false,
			mousewheel: false,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
				1400: {
					slidesPerView: maxPerView,
				},
			},
			initialSlide: 0,
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
		});

		if (this.navs.length) {
			this.element.addEventListener('mixStart', (e: CustomEvent) => {
				this.navs.forEach((i) => {
					i.classList.add('is-hidden');
				});
			});

			this.element.addEventListener('mixEnd', (e: CustomEvent) => {
				this.swiperItem.slideTo(0);
				const activeClass = e.detail?.state?.activeFilter?.selector?.replace(
					'.',
					''
				);
				const ordering = e.detail?.state?.activeSort?.order;
				const sortString = e.detail?.state?.activeSort?.sortString;

				this.navs
					.find((i) => i.classList.contains(activeClass))
					.classList.remove('is-hidden');

				if (activeClass == 'event' && sortString != 'startdate:asc') {
					this.mixitup.sort('startdate:asc');
				} else if (activeClass != 'event' && ordering == 'desc') {
					this.mixitup.sort('default:asc');
				}
			});
		}
	}
}
